import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import React from "react"
import { reservationStatusToStr, RoomReservation } from "../../ostertalertypes";
import { dateToStr } from "../../utils/dateutils";

interface ITableBookings extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    roomReservation: RoomReservation[]
    showGuestName: boolean
    getActionBtn: (res: RoomReservation) => JSX.Element | undefined
}

export const TableBookings: React.FC<ITableBookings> = (props) => {
    return(
        <TableContainer component={Paper}>
        <Table sx={{  }} size="small">
          <TableHead>
            <TableRow className="bg-blue-600 text-white  font-medium">
              {props.showGuestName && <TableCell className="text-white">Gast</TableCell>}
              <TableCell className="text-white">Haus</TableCell>
              <TableCell className="text-white" align="right">Zimmer</TableCell>
              <TableCell className="text-white" align="right">Von</TableCell>
              <TableCell className="text-white" align="right">Bis</TableCell>
              <TableCell className="text-white" align="right">Status</TableCell>
              <TableCell className="text-white" align="right">Aktion</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {props.roomReservation.map((res, i) => (
              <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  {props.showGuestName && <TableCell component="th" scope="row">{res.user?.firstname + " " + res.user?.lastname}</TableCell>}
                  <TableCell component="th" scope="row">{res.houseName}</TableCell>
                  <TableCell align="right">{res.roomName}</TableCell>
                  <TableCell align="right">{dateToStr(res.from)}</TableCell>
                  <TableCell align="right">{dateToStr(res.to)}</TableCell>
                  <TableCell align="right">{reservationStatusToStr(res.status)}</TableCell>
                  <TableCell align="right">
                    {props.getActionBtn(res)}
                  </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
        )
}
